





























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DialogForm, FormOverlay } from '@/components/bwaff';

@Component({
  components: {
    FormOverlay,
    DialogForm,
  },
})
export default class CustomConversionsSending extends Vue {
  close() {
    this.$emit('close');
  }
}
